import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { toggleInscripcion } from '../../../appStore/convocatoria';
import { useConcurso } from '../../../providers/ConcursoProvider';
import {
  getReporteEstadoConcurso,
  getReporteRequisitosDeclarados,
} from '../Gestion/TramitarConcursos/restPostulacionesPuesto';

const AccionesInscripcionWebCC = () => {
  const { idLlamadoConcurso, etapaLlamadoConcurso } = useConcurso();
  const { idEtapaLlamadoConcurso } = etapaLlamadoConcurso;
  const dispatch = useDispatch();

  const FlexDiv = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: auto;
    margin: 18px auto;
  `;

  return (
    <FlexDiv>
      <ButtonGroup>
        {/* PROCESAR */}
        <DropdownButton as={ButtonGroup} id="dropdown-basic-button" title="Procesar">
          <Dropdown.Item
            onClick={() => {
              if (
                window.confirm(
                  'Se cerrará la inscripción del concurso Nª: ' +
                    idLlamadoConcurso +
                    '¿Está seguro?',
                )
              )
                dispatch(toggleInscripcion({ idLlamadoConcurso, abrir: false }));
            }}>
            Cerrar Inscripción
          </Dropdown.Item>
        </DropdownButton>

        {/* REPORTES */}
        <DropdownButton as={ButtonGroup} id="dropdown-basic-button" title="Reportes">
          <Dropdown.Item
            onClick={() =>
              dispatch(getReporteEstadoConcurso({ idLlamadoConcurso, idEtapaLlamadoConcurso }))
            }>
            Postulantes
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => dispatch(getReporteRequisitosDeclarados({ idLlamadoConcurso }))}>
            Requisitos declarados
          </Dropdown.Item>
        </DropdownButton>
      </ButtonGroup>
    </FlexDiv>
  );
};

export default AccionesInscripcionWebCC;
